/* eslint-disable react/no-unstable-nested-components */
import { twClassMerge } from '@healthhub/react-ui';
import { Collapse, Divider, Typography } from 'antd';

import { OutlinedDownArrowIcon, OutlinedRightIcon } from '@shared/assets-icon';
import { sitecoreHomeBaseUrl } from '@shared/configs/configs/config';
import useResponsive from '@shared/hooks/useResponsive';

const { Text } = Typography;

interface LinkoutProps {
  className?: string;
  containerClassName?: string;
  isCollapse?: boolean;
  links: { title: string; url: string }[];
  title?: string;
  viewAllUrl?: string;
}

const Linkout = ({ className, containerClassName, isCollapse = true, links, title, viewAllUrl }: LinkoutProps) => {
  const responsive = useResponsive();

  const renderLinks = () => (
    <div className={twClassMerge('grid grid-cols-1 content-start gap-x-20 lg:gap-y-4', className)}>
      {links.map(({ title, url }) => (
        <a
          className="w-full border-b border-functional-haze p-4 text-sm font-semibold text-primary-green-4 lg:w-auto lg:border-none lg:p-0"
          href={`${sitecoreHomeBaseUrl()}${url}`}
          key={title}
          lang="en"
        >
          {title}
        </a>
      ))}
      {!!viewAllUrl && (
        <a
          className="flex items-center border-b border-functional-haze p-4 text-sm font-semibold text-primary-green-4 lg:w-auto lg:border-none lg:p-0"
          href={`${sitecoreHomeBaseUrl()}${viewAllUrl}`}
          lang="en"
        >
          View All <OutlinedRightIcon />
        </a>
      )}
    </div>
  );

  return (
    <div className={twClassMerge('flex flex-col gap-4', containerClassName)}>
      {!!title && !!isCollapse && (
        <>
          <div className="hidden flex-col gap-4 lg:flex">
            <Text className="text-sm font-semibold text-primary-blue-grey lg:text-base">{title}</Text>
            <Divider className="m-0 w-full border-dashed border-functional-stone" />
          </div>
          {!responsive.lg && (
            <Collapse
              accordion
              className={twClassMerge('w-full border-none', className)}
              expandIcon={({ isActive }) => (
                <OutlinedDownArrowIcon
                  className={twClassMerge(
                    '[&>path]:stroke-primary-green-4 [&>path]:stroke-2 transform duration-300 h-5 w-5 static',
                    isActive && 'rotate-180'
                  )}
                />
              )}
              expandIconPosition="end"
              items={[
                {
                  key: title,
                  label: <span className="text-sm font-semibold text-primary-blue-grey">{title}</span>,
                  children: renderLinks(),
                  className:
                    'border-b border-functional-haze bg-functional-beige [&_.ant-collapse-content-box]:p-0 [&_.ant-collapse-content]:border-none [&_.ant-collapse-header]:flex [&_.ant-collapse-header]:items-center [&_.ant-collapse-header]:p-4',
                },
              ]}
            />
          )}
        </>
      )}
      {!!(responsive.lg || !isCollapse) && renderLinks()}
    </div>
  );
};

export default Linkout;
